import { SortDirection } from '../../../model/scp/base/sort-direction';

export type SupplierType = 'PJ' | 'PF' | 'PE';

export const SUPPLIER_TYPE_OPTIONS: { value: SupplierType; label: string }[] = [
    { value: 'PJ', label: 'Pessoa Jurídica' },
    { value: 'PF', label: 'Pessoa Física' },
    { value: 'PE', label: 'Pessoa Estrangeira' },
];

// Valores monetários/quantidades: zero também conta como "não informado"
export function isEmptyAmount(value?: number | string | null): boolean {
    return value === undefined || value === null || value === '' || Number(value) === 0 || Number.isNaN(Number(value));
}

// Opções do select "Ordenar por": cada campo gera as direções ascendente e descendente
export function buildSortOptions(fields: { field: number; label: string }[]): { value: string; label: string }[] {
    return fields.flatMap((option) => ([
        { value: `${option.field}_${SortDirection.Ascending}`, label: `${option.label} Ascendente` },
        { value: `${option.field}_${SortDirection.Descending}`, label: `${option.label} Descendente` },
    ]));
}

export function toSortValue(sortBy?: number, sortDirection?: number): string {
    return sortBy !== undefined && sortDirection !== undefined ? `${sortBy}_${sortDirection}` : '';
}

export function parseSort(value: string): { sortBy: number; sortDirection: number } | undefined {
    if (!value) return undefined;
    const [sortBy, sortDirection] = value.split('_').map(Number);
    return Number.isNaN(sortBy) || Number.isNaN(sortDirection) ? undefined : { sortBy, sortDirection };
}

// Máscara do documento do fornecedor: CPF para pessoa física, CNPJ para jurídica, livre para estrangeira
export function getSupplierDocumentMask(type?: string | null): string | undefined {
    if (type === 'PF') return '999.999.999-99';
    if (type === 'PE') return undefined;
    return '99.999.999/9999-99';
}

export function getSupplierDocumentLabel(type?: string | null, suffix = ''): string {
    if (type === 'PF') return `CPF do Fornecedor${suffix}`;
    if (type === 'PE') return `Identificação do Fornecedor Estrangeiro${suffix}`;
    return `CNPJ do Fornecedor${suffix}`;
}

// Itens do rascunho (inclusão) são enviados em JSON junto com o cadastro; JSON inválido conta como nenhum item
export function countDraftItems(itemsJson?: string): number {
    try {
        const items = JSON.parse(itemsJson || '[]');
        return Array.isArray(items) ? items.length : 0;
    } catch {
        return 0;
    }
}
